import React from 'react';
import { AlertCircle } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
interface DeadlineBannerProps {
  closeDate: string;
  isClosingSoon: boolean;
}
export function DeadlineBanner({
  closeDate,
  isClosingSoon
}: DeadlineBannerProps) {
  if (isClosingSoon) {
    return <div className="bg-red-600 text-white py-3 px-4" data-id="element-195">
        <div className="max-w-7xl mx-auto flex items-center justify-center space-x-3" data-id="element-196">
          <AlertCircle className="h-5 w-5 flex-shrink-0" data-id="element-197" />
          <span className="font-medium" data-id="element-198">Store closes soon — order now!</span>
          <CountdownTimer targetDate={closeDate} label="Closes in" size="sm" showIcon={false} data-id="element-199" />
        </div>
      </div>;
  }
  return <div className="bg-gray-100 border-b border-gray-200 py-2 px-4" data-id="element-200">
      <div className="max-w-7xl mx-auto flex items-center justify-center" data-id="element-201">
        <CountdownTimer targetDate={closeDate} label="Order by" size="sm" data-id="element-202" />
      </div>
    </div>;
}